var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTtLogo = function SvgTtLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#697477",
    d: "M72.03 15.354 7.384 51.717v12.93l26.667-15V80l11.313-6.364V43.283l26.666-15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AACC8",
    d: "M34.05 0v30.354l-26.666-15v12.929l17.534 9.863 20.446-11.501V6.364zM54.496 41.854l-5.9 3.32v6.29L72.03 64.648v-12.93z"
  })));
};
export { SvgTtLogo as ReactComponent };
export default __webpack_public_path__ + "dd30fd13cb2ea0d12074e7a08e6d9835.svg";